// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imagefile-root {
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: 50% 50%;
  grid-template-areas: "header header" "left right";
}
.imagefile-root > div {
  flex: 1;
  overflow: auto;
}
.imagefile-root > div.header {
  grid-area: header;
}
.imagefile-root > div.left-container {
  grid-area: left;
  padding: 0 10px 0 24px;
}
.imagefile-root > div.left-container .left-toolbar {
  padding: 0 0 10px 0;
}
`, "",{"version":3,"sources":["webpack://./src/Component/ImageFile/ImageFileRoot/ImageFileRoot.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,4BAAA;EACA,8BAAA;EACA,iDAAA;AACF;AANA;EAUI,OAAA;EACA,cAAA;AADJ;AAGI;EACE,iBAAA;AADN;AAII;EACE,eAAA;EACA,sBAAA;AAFN;AAAI;EAKI,mBAAA;AAFR","sourcesContent":[".imagefile-root {\n  height: 100%;\n  display: grid;\n  grid-template-rows: auto 1fr;\n  grid-template-columns: 50% 50%;\n  grid-template-areas:\n    \"header header\"\n    \"left right\";\n\n  >div {\n    flex: 1;\n    overflow: auto;\n\n    &.header {\n      grid-area: header;\n    }\n\n    &.left-container {\n      grid-area: left;\n      padding: 0 10px 0 24px;\n\n      .left-toolbar {\n        padding: 0 0 10px 0;\n      }\n    }\n  }\n\n}\n\n@drawer-width: 600px;@primary-color: #137CBD;@info-color: #137CBD;@success-color: #0F9960;@warning-color: #D9822B;@error-color: #DB3737;@link-color: #137CBD;@font-size-base: 14px;@heading-color: rgba(0, 0, 0, 0.85);@text-color: rgba(0, 0, 0, 0.65);@text-color-secondary: rgba(0, 0, 0, .45);@disabled-color: rgba(0, 0, 0, .25);@border-radius-base: 0px;@border-color-base: #d9d9d9;@box-shadow-base: 0 2px 8px rgba(0, 0, 0, 0.15);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
